<div class="pt-2">
  <tea-shop-fe-hero></tea-shop-fe-hero>
  <tea-shop-fe-home-carousel></tea-shop-fe-home-carousel>
  <tea-shop-fe-home-featured></tea-shop-fe-home-featured>
  <tea-shop-fe-blog-list></tea-shop-fe-blog-list>
</div>
